export default __webpack_public_path__ + "checkmark.9a775f5e902c02cd77baf4f296e4bebe.svg";